var _helper = require('./helper');

/**
 * Module for accountNumber and accountValidation fields
 */
module.exports = {
	
	/**
	 * initilize the account fields to hook events 
	 */
	init: function(params) {
		var self = this,
			req_attr = 'rs-account-request',
			$accountFields = $('[' + req_attr + ']');
		
		self.params = params;				
		self.req = {};
		self.$companyNames = $('#company\\.name,#company\\.nameKana,#company\\.name2', params.$form);
		self.isJP = $('#company\\.nameKana').length > 0;

		self.$companyNames.each(function(index, field) {
			var accountVerified = params.accountVerified === true;
			var hasValue = $.trim(field.value).length > 0;
			
			self.disableEnableFields(field, accountVerified, hasValue);
		});
		
		$(document).on('accounts.populated', $.proxy(self.onAccountChange, self));
		
		$accountFields.on('change', $.proxy(self.onAccontsFieldsChange, self, $accountFields, req_attr));
		
		self.toggleHearAbout(params.accountVerified === true);
	},
	
	/**
	 * show/hide the hearAbout field
	 */
	toggleHearAbout: function(hide) {
		var self = this;
		$('#hearAbout', self.params.$form).parents('.form-item').toggleClass('hidden', hide);
	},	
	
	/**
	 * When account fields changed
	 */
	onAccontsFieldsChange: function($accountFields, req_attr, e) {		
		var self = this, 
			$emptyFields = $accountFields.filter(function() { return $(this).val() === ''; }),
			$target = $(e.target);

		if($emptyFields.length === 0) {
			$accountFields.each(function(index, field) {
				var k = $(field).attr(req_attr);
				self.req[k] = field.value;
			});
			$(document).trigger('accounts.populated');
		}else if($.trim($target.val()) === '') {
			$target.removeClass('has-error verified');
			$target.siblings('.text-error-icon,.text-verified-icon').addClass('hidden');
			self.$companyNames.each(function(index, field) {
				self.disableEnableFields(field, false);
			});			
		}
	},
	
	/**
	 * handler for account fields change
	 */
	onAccountChange: function(e) {
		var self = this, 
			serviceUri = 'accountDetails';
		
		var promise = _helper.ajaxPost(serviceUri, self.req);
		promise.then($.proxy(self.handleResult, self));
	},

	/**
	 * handle the result of accountDetails ajax call 
	 */
	handleResult: function(response) {
		
		var self = this;
		
		$('.unkown-account-message-container').toggleClass('hidden', response.valid === true);
		$('[rs-account-request]')
			.toggleClass('has-error', response.valid === false)
			.toggleClass('verified', response.valid === true)
			.siblings('.text-error-icon').toggleClass('hidden', response.valid === true)
			.siblings('.text-verified-icon').toggleClass('hidden', response.valid === false);
		
		response.addresses = response.addresses || [];
		
		if(response.addresses.length > 1) {
			self.doSelectAddressDialog(response);
		}else {
			if(response.addresses.length === 1) {
				self.setSelectedAddress(response, 0);
			}
			self.populateFields(response);
			self.toggleHearAbout(response.valid === true);
		}
		
	},
	
	/**
	 * disable/enable company names fields
	 */
	disableEnableFields: function(field, accountVerified, hasValue) {
		var self = this, $field = $(field), isJP = self.isJP;
		switch(field.id) {
		    case 'company.name':
		    	var disabled = accountVerified && hasValue;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    case 'company.name2':
		    	var disabled = accountVerified && !isJP;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    case 'company.nameKana':
		    	var disabled = accountVerified;
		    	$field.prop('readonly', disabled);
		    	$field.toggleClass('disabled', disabled);
		        break;
		    default:
		        break;
		}		
	},	
	
	/**
	 * populate the form fields with json result 
	 */
	populateFields: function(data) {
		var self = this, $form = self.params.$form;
		
		var $fields = $('input[name]:not([class~=hidden]):not([rs-account-request]):not([type=hidden]):not([name^=credential\\.]),select[name]:not([class~=hidden]):not([rs-account-request])', $form);
		
		$fields.each($.proxy(self.populateField, self, data));
	},
	
	/**
	 * put value to single field
	 */
	populateField: function(data, index, field) {
		var self = this;
		
		var value = self.getDataByFieldName(field.name, data),
			$field = $(field);
		var fieldTag = field.tagName.toLowerCase();
		var fieldType = field.type.toLowerCase();
		
		// $.trim takes care of null/undefined as well
		// ignore the field if value is empty/null/undefined
		var isEmpty = $.trim(value).length === 0;
		if(!isEmpty) {
			$(field).val(value).trigger('change');
		}
		
		// disable/enable 'Company name' and 'Trading As' fields
		self.disableEnableFields(field, data.valid === true, !isEmpty);
	},
		
	/**
	 * get value from json response by form field name
	 */
	getDataByFieldName: function(fieldName, data) {
		if(!$.isPlainObject(data)) {
			return;
		}
		var self = this, pos = fieldName.indexOf('.');
		if(pos > -1) {		
			data = data[fieldName.slice(0,pos)];
			return self.getDataByFieldName(fieldName.slice(pos+1), data);
		}
		
		return data[fieldName];
	},
			
	/**
	 * show dialog for selecting an address 
	 * and set the selected one into the json result
	 */
	doSelectAddressDialog: function(response) {
		var self = this, $dlg = $("#addresses-dialog");
				
		self.setupDialog($dlg, response);
				
		$dlg.modal('show');		
	},
	
	/**
	 * center the dialog
	 */
	centerDialog: function($dlg) {

		var $d = $('.modal-dialog', $dlg),
			$w = $(window),
			top = $w.scrollTop();

		$d.css({
			'margin-top':($w.height()-$d.outerHeight())/2
		});
	},		
	
	/**
	 * configure dialog
	 */
	setupDialog: function($dlg, response) {

		var self = this, $container = $('.addresses-container', $dlg);
		
		self.populateAddresses($dlg, response, $container);
		
		self.installEventHandlers($dlg, response, $container);
		
    	//initially select the first address
		var val = self.lastSel || '0';
		$('input[type=radio][value=' + val + ']', $container).parents('.address-container').click();
	},
	
	/**
	 * populate the addresses list 
	 */
	populateAddresses: function($dlg, response, $container) {
		var self = this, 
			$contact = $('.contact-id-container .contact-id', $dlg),
			addresses = response.addresses,
			$row;
		
		// display contact ID
		$contact.text(response.contact);
		
		//dynamically add  addresses
		$container.empty();
		for(var i = 0; i < addresses.length; i++) {
			if(i%2 === 0) {
				$row = $('<div class="row"/>').appendTo($container);
			}
			self.buildAddressCell(addresses[i], i).appendTo($row);
		}
		$container.prepend($container);
	},
	
	/**
	 * Install event handler
	 */
	installEventHandlers: function($dlg, response, $container) {
		var self = this, 
			$selectButton = $('button.select-button', $dlg),
			$addressContainer = $('.address-container', $dlg);

		// hook click event to select an address
		$addressContainer.off('click').on('click', function(e) {
    		
			$addressContainer.removeClass('selected');
    		
    		var $radio = $('input[type=radio]', this);
    	
    		if(e.target !== $radio[0]) {
    			$radio.click();
    			$(this).addClass('selected');
    		}
    	});
		
		// Handle 'click' event on select button
		$selectButton.off('click').on('click', function() {
			self.select($dlg, response, $container);
		});
    	
    	// hook dblclick event to select an address
    	$('.address-container', $dlg).on('dblclick', function(e) {
    		$(this).trigger('click');
    		$selectButton.trigger('click');
    	});
    	
    	$dlg.on('shown.bs.modal', function() {
    		self.centerDialog($dlg);
    	});
	},
	
	/**
	 *select an address
	 */
	select: function($dlg, response, $container) {
		var self = this, addresses = response.addresses;
		
    	var sel = $('input[type=radio]:checked').val();
    	self.setSelectedAddress(response, sel);
    	self.populateFields(response);
    	self.toggleHearAbout(response.valid === true);
    	self.lastSel = sel;
    	
    	self.closeDialog($dlg, $container);
	},
	
	/**
	 * set the selected address to response object
	 */
	setSelectedAddress: function(response, sel) {
		var addresses = response.addresses;
		
    	response.address = addresses[sel];
    	response.company = response.address.company;
    	response.soldTo = response.address.soldTo;
    	
    	$('#contact-id').val(response.contact);
    	$('#sold-to-id').val(response.soldTo);
	},
	
	/**
	 * close dialog
	 */
	closeDialog: function($dlg, $container) {
		$container.empty();
    	$dlg.modal('hide');
	},
	
	/**
	 * build a table cell to display an address
	 */
	buildAddressCell: function(address, index) {
		
		var self = this;
		
		var $cell = $('<div class="address-container col-md-6' + (index%2 === 0 ? ' first' : '') + '"><div class="selection col-md-1"><input type="radio" name="wantedAddress" value="' + index + '"></div></div>');
		var $div = $('<div class="address col-md-11"/>').appendTo($cell);
		
		//Keep soldTo at the top
		$div.append(self.buildAddressItem(address.soldTo, 'sold-to'));
		
		for(var key in address) {
			if(key === 'soldTo') {
				continue;
			}
			var item = address[key];
			if(!item) continue;
			if(key === 'company') {
				$div.append(self.buildAddressItem(item.name));
				$div.append(self.buildAddressItem(item.name2));
			}else{
				$div.append(self.buildAddressItem(item));
			}
		}
				
		return $cell;
	},
	
	buildAddressItem: function(text, cls) {
		if(!cls) 
			cls = '';
		else
			cls = ' ' + cls;
		
		if (!text)
			text = '&nbsp;';
		
		return '<div class="address-item' + cls + '" title="' + text + '">' + text + '</div>';
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/account.js
// module id = 256
// module chunks = 4